import { ETableStructureAlign, ETableStructureType, TTableStructure } from 'ui/EasTable/types';
import { TEmProductFileUploadsRow } from 'redux/reducers/emProductFileUploads/types';
import { DATES, DATES_ID } from '../../services/constants/dates-constants';
import { TFiscalReportListItem } from '../../redux/reducers/fiscalReports/types';

export const tableStructure: TTableStructure<keyof TEmProductFileUploadsRow>[] = [
	{
		name: 'ID',
		selector: 'id',
		show: false,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.NUMBER,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Uploaded at',
		selector: 'uploadedAt',
		show: true,
		sortable: true,
		filterable: true,
		filter: [
			[DATES_ID.TODAY, DATES.TODAY],
			[DATES_ID.YESTERDAY, DATES.YESTERDAY],
			[DATES_ID.LAST_7_DAYS, DATES.LAST_7_DAYS],
			[DATES_ID.LAST_30_DAYS, DATES.LAST_30_DAYS],
			[DATES_ID.THIS_MONTH, DATES.THIS_MONTH],
			[DATES_ID.LAST_MONTH, DATES.LAST_MONTH],
			[DATES_ID.THIS_QUARTER, DATES.THIS_QUARTER],
			[DATES_ID.LAST_QUARTER, DATES.LAST_QUARTER],
			[DATES_ID.THIS_YEAR, DATES.THIS_YEAR],
			[DATES_ID.LAST_YEAR, DATES.LAST_YEAR],
			[DATES_ID.CUSTOM_RANGE, DATES.CUSTOM_RANGE],
		],
		colSpan: 1,
		type: ETableStructureType.DATE,
		align: ETableStructureAlign.CENTER,
	},

	{
		name: 'EM Name',
		selector: 'fullName',
		show: true,
		sortable: true,
		filterable: false,
		colSpan: 2,
		type: ETableStructureType.EM,
		value: (item: TEmProductFileUploadsRow) => {
			return { id: item.emId, name: item.fullName };
		},
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Uploaded file',
		selector: 'uploadedFileName',
		show: true,
		sortable: true,
		filterable: false,
		searchable: true,
		colSpan: 2,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Processed at',
		selector: 'processedAt',
		show: true,
		sortable: true,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.DATE_TIME,
		align: ETableStructureAlign.CENTER,
	},

	{
		name: 'Processed file',
		selector: 'processedFileName',
		show: true,
		sortable: true,
		filterable: false,
		colSpan: 2,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Products/Variants count',
		selector: 'variantsCount',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.NUMBER,
		align: ETableStructureAlign.RIGHT,
	},
	{
		name: 'Processed rows',
		selector: 'processedRowsCount',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.NUMBER,
		align: ETableStructureAlign.RIGHT,
	},
	{
		name: 'Status',
		selector: 'status',
		show: true,
		sortable: true,
		filterable: true,
		colSpan: 1,
		type: ETableStructureType.STATUS,
		align: ETableStructureAlign.LEFT,
		filter: [
			['Processing', 'Processing'],
			['Processed', 'Processed'],
			['Failed', 'Failed'],
		],
		colors: [
			['Processing', 'info.light'],
			['Processed', 'success.light'],
			['Failed', 'error.light'],
		],
	},
	{
		name: 'Error Message',
		selector: 'errorMessage',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.TEXT,
		align: ETableStructureAlign.LEFT,
	},

	{
		name: 'Author',
		selector: 'author',
		show: true,
		sortable: true,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.USER,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Actions',
		selector: 'actions',
		noName: true,
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.BUTTONS,
		align: ETableStructureAlign.LEFT,
		buttons: [{ name: 'Download File' }, { name: 'Download Processed File' }],
		buttonFilter: item => {
			const buttons = [] as { name: string }[];
			if (item.uploadedFileName) buttons.push({ name: 'Download Uploaded' });
			if (item.processedFileName) buttons.push({ name: 'Download Processed' });
			return buttons;
		},
	},
];
